// extracted by mini-css-extract-plugin
module.exports = {"singleImage":"DeviceImages_singleImage__RLwvR","singleImage__active":"DeviceImages_singleImage__active__HsM4F"};